let currentY = 0;

export function bodyFixed() {
  currentY = window.scrollY;
  document.body.style.position = 'fixed';
  document.body.style.top = `${-1 * currentY}px`;
}

export function bodyStatic() {
  document.body.style.position = 'static';
  window.scrollTo(0, currentY);
}